export interface BodyType {
  id: string;
  name: string;
  gender: 'male' | 'female';
  description: string;
  image: string;
  celebrity: string;
}

export interface DietProfile {
  id: string;
  user_id: string;
  weight: number;
  height: number;
  waist: number;
  chest: number;
  hips: number;
  activity_level: 'low' | 'medium' | 'high';
  current_diet: string;
  allergies: string;
  goal: 'lose' | 'gain' | 'muscle';
  target_areas: string[];
  meals_per_day: number;
  favorite_foods: string[];
  body_image?: string;
  blood_results?: string;
  blood_results_image?: string;
  desired_body_type?: string;
  created_at: string;
  updated_at: string;
}

export interface DietPlan {
  id: string;
  diet_profile_id: string;
  start_date: string;
  end_date: string;
  meals: {
    time: string;
    name: string;
    foods: string[];
    calories: number;
    protein: number;
    carbs: number;
    fats: number;
  }[];
  recommendations: string[];
  supplements: string[];
  created_at: string;
}

export const bodyTypes: BodyType[] = [
  {
    id: 'slim-male',
    name: 'Slim & Lean',
    gender: 'male',
    description: 'Slim and naturally lean physique with subtle muscle definition',
    image: 'https://images.unsplash.com/photo-1506634064465-7dab4de896ed?w=400&fit=crop',
    celebrity: 'Timothy Chalamet'
  },
  {
    id: 'athletic-male',
    name: 'Athletic & Defined',
    gender: 'male',
    description: 'Athletic build with clear muscle definition and low body fat',
    image: 'https://images.unsplash.com/photo-1534438327276-14e5300c3a48?w=400&fit=crop',
    celebrity: 'Brad Pitt (Fight Club)'
  },
  {
    id: 'muscular-male',
    name: 'Muscular & Strong',
    gender: 'male',
    description: 'Heavily muscled physique with significant size and strength',
    image: 'https://images.unsplash.com/photo-1571019614242-c5c5dee9f50b?w=400&fit=crop',
    celebrity: 'Dwayne "The Rock" Johnson'
  },
  {
    id: 'slim-female',
    name: 'Slim & Elegant',
    gender: 'female',
    description: 'Naturally slim and graceful physique',
    image: 'https://images.unsplash.com/photo-1594381898411-846e7d193883?w=400&fit=crop',
    celebrity: 'Angelina Jolie'
  },
  {
    id: 'curvy-female',
    name: 'Curvy & Proportional',
    gender: 'female',
    description: 'Balanced curves with a defined waist',
    image: 'https://images.unsplash.com/photo-1529903384028-929ae5dccdf1?w=400&fit=crop',
    celebrity: 'Kylie Jenner'
  },
  {
    id: 'hourglass-female',
    name: 'Hourglass & Strong',
    gender: 'female',
    description: 'Pronounced curves with strong lower body',
    image: 'https://images.unsplash.com/photo-1583454110551-21f2fa2afe61?w=400&fit=crop',
    celebrity: 'Nicki Minaj'
  }
];